import React, { ChangeEvent } from 'react';
import { emptyFn } from '@core/interfaces/emptyFn';
import { BindedHandler } from '@core/interfaces/binded-handler';
import InputComponent from '@ui/components/Input/Input.component';
import useDictionary from '@ui/hooks/useDictionary';
import { lang } from '@lang/interfaces/lang';

interface IProps {
    lang: lang;
    sim: string;
    simApn: string;
    simLogin: string;
    simPassword: string;
    onSimApnChange: BindedHandler<ChangeEvent<HTMLInputElement>>;
    onSimLoginChange: BindedHandler<ChangeEvent<HTMLInputElement>>;
    onSimPasswordChange: BindedHandler<ChangeEvent<HTMLInputElement>>;
    onInputClick: emptyFn;
}

const Component: React.FC<IProps> = ({
    lang,
    sim,
    simApn,
    simLogin,
    simPassword,
    onSimApnChange,
    onSimLoginChange,
    onSimPasswordChange,
    onInputClick,
}: IProps) => {
    const getWord = useDictionary();
    const simNum = sim.split('sim')[1];

    return (
        <>
            <InputComponent
                label={`${getWord('simApn')}${simNum}`}
                name="sim-apn"
                type="text"
                lang={lang}
                description={`${getWord('simApnTooltip')} ${simNum}`}
                value={simApn}
                onChange={onSimApnChange.bind(this, sim)}
                onClick={onInputClick}
                onFocus={onInputClick}
            />
            <InputComponent
                label={`${getWord('simLogin')}${simNum}`}
                name="sim-login"
                type="text"
                lang={lang}
                description={`${getWord('simLoginTooltip')} ${simNum}`}
                value={simLogin}
                onChange={onSimLoginChange.bind(this, sim)}
                onClick={onInputClick}
                onFocus={onInputClick}
            />
            <InputComponent
                label={`${getWord('simPassword')}${simNum}`}
                name="sim-password"
                type="text"
                lang={lang}
                description={`${getWord('simPasswordTooltip')} ${simNum}`}
                value={simPassword}
                onChange={onSimPasswordChange.bind(this, sim)}
                onClick={onInputClick}
                onFocus={onInputClick}
            />
        </>
    );
};

const SimItemComponent = React.memo(Component);

export default SimItemComponent;
